/**
 * @readonly
 * @enum {string}
 */
export const TpmsBatteryLevels = Object.freeze({
    NORMAL: 'NORMAL',
    BATTERY_LEVEL_WARNING: 'BATTERY_LEVEL_WARNING',
    BATTERY_LEVEL_CRITICAL: 'BATTERY_LEVEL_CRITICAL'
})
